import styled from "styled-components";

export default styled.div`
  cursor: pointer;
  width: 328px;
  align-self: stretch;
  ${({short}) => short ? `height: 52px;` : `height: 80px;`}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #EEF3F6;

  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: #263628;

  &.active {
    background-color: #D7E0E6;
  }
`
